import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';
import { WorkflowType } from 'src/enums/EWorkflow';

const selectScenarioCountsState = (state: RootState) => state.scenarioCounts;

export const selectScenarioCounts = createSelector(
	[selectScenarioCountsState],
	(state) =>
		state?.counts || {
			[WorkflowType.TEXT]: 0,
			[WorkflowType.CALL]: 0,
			[WorkflowType.WEBHOOK]: 0,
			[WorkflowType.CALENDAR]: 0,
			[WorkflowType.INTAKE]: 0,
			[WorkflowType.EMAIL]: 0,
			total: 0,
		},
);

export const selectScenarioLimit = createSelector(
	[selectScenarioCountsState],
	(state) => state?.limit || 100,
);

export const selectCanAddScenario = createSelector(
	[selectScenarioCounts, selectScenarioLimit],
	(counts, limit) => {
		const canAdd = counts.total <= limit;
		return canAdd;
	},
);

export const selectRemainingScenarios = createSelector(
	[selectScenarioCounts, selectScenarioLimit],
	(counts, limit) => limit - counts.total,
);
